<template>
  <div
    v-loading="loading"
    class="container_padding course"
    :style="
      $route.name == 'eLearningIndex'
        ? ''
        : { height: wHeight - 93 - (wWidth < 976 ? 49 : 0) + 'px' }
    "
  >
    <!-- <div v-if="wWidth < 976">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('message.learning_content')" name="content"></el-tab-pane>
        <el-tab-pane :label="$t('message.course_catalog')" name="catalog"></el-tab-pane>
      </el-tabs>
    </div>-->
    <el-row :gutter="16" class="course_content">
      <el-col
        :xs="24"
        :sm="24"
        :md="16"
        :lg="17"
        :xl="17"
        v-if="(wWidth < 976 && activeName == 'content') || wWidth >= 976"
        style="position: relative; align-items: center"
      >
        <div class="courseView">
          <div class="courseView_title">
            <span
              >{{
                $t("message.chapter", [
                  $t(
                    `message.numberToCN[${
                      course &&
                      course.chapters &&
                      course.chapters.length > 0 &&
                      parseInt(chapterIndex) >= 0
                        ? course.chapters[parseInt(chapterIndex)].priority
                        : 0
                    }]`
                  ),
                ])
              }}&nbsp;</span
            >
            <span v-if="sectionIndex >= 0 && parseInt(sectionIndex) >= 0"
              >{{
                $t("message.section", [
                  course && course.chapters && parseInt(chapterIndex) >= 0
                    ? course.chapters[parseInt(chapterIndex)].sections[
                        parseInt(sectionIndex)
                      ].priority
                    : 0,
                ])
              }}&nbsp;</span
            >
            <span>{{ content && content.title }}</span>
          </div>
          <div class="courseView_content" ref="viewContent">
            <!-- 視頻 -->
            <!-- <div v-for="item in getVideo" :key="item.id" class="courserView_video">
              <video width="100%" height="400" controls>
                <source
                  :src="`${basePathUrl}course-files/${item.id}.${item.extension}`"
                  :type="item.contentType"
                />
              </video>
            </div>-->
            <!-- 正文 -->
            <div
              v-html="content && content.text"
              id="courseView_html"
              class="html-box courseView_html"
            ></div>
            <!-- 切換章按鈕 -->
            <div v-if="content && content.sections" class="switch">
              <mBtn @click="startThisChapter">{{
                $t("message.start_chapter_learn")
              }}</mBtn>
            </div>
            <!-- 切換小節按鈕 -->
            <div v-if="content && !content.sections" class="switch">
              <!-- 上一章 -->
              <mBtn v-if="sectionIndex && sectionIndex != 0" @click="prev">{{
                $t("message.prev_section")
              }}</mBtn>
              <!-- 返回本章 -->
              <mBtn v-if="sectionIndex == 0" @click="returnThisChapter">{{
                $t("message.return_this_chapter")
              }}</mBtn>
              <!-- 下1節 -->
              <mBtn
                v-if="
                  course &&
                  course.chapters &&
                  Number(sectionIndex) >= 0 &&
                  Number(sectionIndex) + 1 <
                    course.chapters[Number(chapterIndex)].sections.length
                "
                @click="next"
                >{{ $t("message.next_section") }}</mBtn
              >
              <!-- 進入下一章 -->
              <mBtn
                v-if="
                  course &&
                  course.chapters &&
                  Number(sectionIndex) >= 0 &&
                  Number(sectionIndex) + 1 >=
                    course.chapters[Number(chapterIndex)].sections.length &&
                  course.chapters.length > chapterIndex + 1
                "
                @click="startNextChapter"
                >{{ $t("message.start_next_chapter") }}</mBtn
              >
              <!-- 進入模擬考試 -->
              <mBtn
                v-if="
                  course &&
                  course.chapters &&
                  course.chapters.length == chapterIndex + 1 &&
                  course.chapters[Number(chapterIndex)].sections.length ==
                    sectionIndex + 1
                "
                :disabled="$store.state.isPreview"
                @click="toTest"
                >{{ $t("message.to_test") }}</mBtn
              >
            </div>
            <!-- 音頻 -->
            <div v-if="content && content.id" class="courserView_audio">
              <audio
                ref="myAudio"
                :src="`${basePathUrl}courseware/audios/${content.id}${isApple}?lang=${soundLocale}`"
                controls
                style="display: none"
                @ended="audioEnd"
              ></audio>
            </div>
            <div v-if="content && content.code == 'test'" class="testBtn">
              <!-- <mBtn :disabled="!canTest" @click="toTest">參與模擬考試</mBtn> -->
              <mBtn @click="toTest" :disabled="$store.state.isPreview">{{
                $t("message.take_the_mock_test")
              }}</mBtn>
            </div>
          </div>
        </div>
        <!-- <div class="x-mp3-progress">
          <div class="x-now-progress" :style="{width: progress}"></div>
        </div>-->
        <div v-if="hasAudio" class="videoControl">
          <div class="control_item" @click="replay">
            <img src="../../../assets/web/Replay.png" />
            <span>{{ $t("message.replay") }}</span>
          </div>
          <div v-if="audio.pause" class="control_item" @click="play">
            <img src="../../../assets/web/Continue.png" />
            <span>{{ $t("message.play") }}</span>
          </div>
          <div v-if="!audio.pause" class="control_item" @click="pause">
            <img src="../../../assets/web/Pause.png" />
            <span>{{ $t("message.pause") }}</span>
          </div>
          <!-- <div v-if="!audio.muted" class="control_item" @click="muteMe">
            <img src="../../../assets/web/Mute.png" />
            <span>{{$t('message.muteMe')}}</span>
          </div>
          <div v-if="audio.muted" class="control_item" @click="sound">
            <img src="../../../assets/web/Sound.png" />
            <span>{{$t('message.sound')}}</span>
          </div>-->
        </div>
      </el-col>
      <el-col
        :xs="24"
        :sm="24"
        :md="8"
        :lg="7"
        :xl="7"
        v-if="(wWidth < 976 && activeName == 'catalog') || wWidth >= 976"
      >
        <div class="courseList">
          <div class="courseList_title">{{ course.title }}</div>
          <div class="courseList_content">
            <div class="search">
              <el-input
                :placeholder="$t('message.search_chapter_placeholder')"
                v-model="search"
              >
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
            <el-menu
              class="el-menu-vertical-demo"
              :default-active="activeNames"
              active-text-color="#16B695"
              :default-openeds="defaultOpeneds"
              unique-opened
            >
              <el-submenu
                v-for="(item, index) in course &&
                course.chapters &&
                course.chapters.filter(
                  (data) =>
                    !search ||
                    data.title.toLowerCase().includes(search.toLowerCase())
                )"
                :key="index"
                :index="String(index)"
              >
                <template slot="title">
                  <div
                    @click.stop="handleOpenAndClose(index)"
                    style="margin-right: 35px"
                  >
                    <span
                      >{{
                        $t("message.chapter", [
                          $t(
                            `message.numberToCN[${
                              item.priority ? item.priority : ""
                            }]`
                          ),
                        ])
                      }}
                      {{ item.title }}&nbsp;</span
                    >
                    <img
                      v-if="item.link && item.link != ''"
                      src="../../../assets/web/Link.png"
                      style="width: 20px"
                      @click="openLink(item.link)"
                    />
                  </div>
                </template>
                <el-menu-item-group v-if="item.sections.length > 0">
                  <div class="search sections_search">
                    <el-input
                      :placeholder="$t('message.search_chapter_placeholder')"
                      v-model="searchSections"
                    ></el-input>
                  </div>
                  <el-menu-item
                    v-for="(section, sectionIndex) in item.sections &&
                    item.sections.filter(
                      (data) =>
                        !searchSections ||
                        data.title
                          .toLowerCase()
                          .includes(searchSections.toLowerCase())
                    )"
                    :key="sectionIndex"
                    :index="String(index) + '-' + String(sectionIndex)"
                    @click="handleSectionChange(section, index, sectionIndex)"
                  >
                    <img
                      src="../../../assets/web/Chapter.png"
                      alt
                      width="20px"
                    />
                    {{ $t("message.section", [section.priority]) }}
                    {{ section.title }}
                    &nbsp;
                    <img
                      v-if="section.link && section.link != ''"
                      src="../../../assets/web/Link.png"
                      style="width: 20px"
                      @click.stop="openLink(section.link)"
                    />
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>
            </el-menu>

            <!-- 右側菜單（tree） -->
            <!-- <el-tree
              ref="tree"
              :data="course.chapters"
              :props="defaultProps"
              node-key="index"
              :default-expanded-keys="[1,2,3]"
              :filter-node-method="filterNode"
              @node-click="nodeClick"
            ></el-tree>-->

            <div class="toTest_btn">
              <mBtn
                v-if="
                  checkHasAssessment &&
                    questionnaire.length > 0 &&
                    !$store.state.auth
                "
                @click="toTest"
                :disabled="$store.state.isPreview"
                width="100%"
                >{{ $t("message.practice_test") }}</mBtn
              >
            </div>

            <Questionnaire></Questionnaire>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 問卷彈窗 -->
    <QuestionTipsDialog :courseTitle="course.title" :show="showQuestionTips" :id="questionnaire.length > 0 && questionnaire[0].id" @close="showQuestionTips = false" @handleContinue="showQuestionTips = false"></QuestionTipsDialog>
  </div>
</template>

<script>
import CourseAPI from "../../../api/CourseAPI";
import UserCourseAPI from "../../../api/UserCourseAPI";
import UserAssessmentsAPI from "../../../api/UserAssessmentsAPI";
import mBtn from "../../../components/mBtn";
import { basePathUrl } from "../../../api/axios";
import Questionnaire from "../../../components/Questionnaire";
import AudioCheckAPI from "../../../api/AudioCheckAPI";
import QuestionTipsDialog from "../../../components/QuestionTipsDialog";
export default {
  components: { mBtn, Questionnaire, QuestionTipsDialog },
  data() {
    return {
      loading: false,
      testLoading: false,
      course: {},
      activeNames: null,
      content: null,
      basePathUrl: basePathUrl,
      audio: {
        pause: true,
        muted: false,
      },
      progress: "0%",
      search: null,
      searchSections: null,
      prevSection: {},
      nextSection: {},
      chapterIndex: null,
      sectionIndex: null,
      soundLocale: "ZH_TW",
      last: null,
      firstLoad: true,
      activeName: "content",
      defaultProps: {
        children: "sections",
        label: "title",
      },
      filterCourse: [],
      defaultOpeneds: [],
      hasAudio: true,
      showQuestionTips: false,
      questionnaire: [],
      checkHasAssessment: false,
    };
  },
  watch: {
    $route(to, from) {
      this.activeName = this.$route.query.activeName || "content";
      document.getElementsByClassName("courseView_content")[0].scrollTop = 0;
      this.get(this.$route.query.chapterIndex);
    },
    content() {
      this.audio = {
        pause: true,
        muted: false,
      };
    },
    isLast() {
      // console.log(this.isLast);
      this.last = this.isLast;
    },
    course(newVal) {
      // console.log("newVal", newVal);
      // console.log("this.course", this.course);
      const last = this.last;
      if (this.firstLoad && last && last.id && this.course && this.course.id) {
        this.firstLoad = false;
        this.lastLocation();
      }
    },
    activeName(val) {
      // console.log("abc", val);
      this.$router.push({
        query: {
          ...this.$route.query,
          activeName: val,
        },
      });
    },
    // search() {
    //   this.filterCourse = this.filterMenu(this.course.chapters, this.search);
    // }
  },
  computed: {
    wWidth() {
      return this.$store.state.wWidth;
    },
    wHeight() {
      return this.$store.state.wHeight;
    },
    // chaptersTree(){
    //   const chapters = this.course.chapters;
    //   let data = [];
    //   data = chapters.
    //   return data
    // },
    percentage() {
      return function (val) {
        return parseInt(val.replace("%", ""));
      };
    },
    canTest() {
      const chapters = this.course.chapters;
      return chapters.find((item) => parseInt(item.progress) < 100)
        ? false
        : true;
    },
    getImage() {
      const files = this.content && this.content.files;
      let arr = [];
      if (files) {
        arr = files.filter((item) => item.type == "IMAGE");
      }
      return arr;
    },
    getAudio() {
      const files = this.content && this.content.files;
      let object = {};
      if (files && files.length > 0) {
        object = files.find((item) => item.type == "AUDIO");
      }
      return object;
    },
    getVideo() {
      const files = this.content && this.content.files;
      let arr = [];
      if (files) {
        arr = files.filter((item) => item.type == "VIDEO");
      }
      return arr;
    },
    // getSearch(){
    //   const key = this.search;
    //   let node = this.course.chapters;
    //   let arr = [];
    //   for(let i in node){
    //     const data = node[i].sections;
    //     for(let j in data){
    //       const childData = data[j];
    //       if(childData.title == key){
    //         arr.push
    //       }
    //     }
    //   }
    // },
    // contentTitle(){
    //   const title = this.content.title;
    //   if(this.$route.query.sectionIndex){
    //     return `第`
    //   }
    // },
    isLast() {
      return this.$store.state.last;
    },
    myQuery() {
      return this.$route.query;
    },
    isApple() {
      return this.$store.state.isApple ? "/iOS" : "";
    },
  },
  methods: {
    // 过滤
    // filterMenu(menuList, menuCode) {
    //   return menuList.filter(item => item.title.indexOf(menuCode) > -1).map(item => {
    //       item = Object.assign({}, item);
    //       if (item.sections) {
    //         item.sections = this.filterMenu(item.sections, menuCode);
    //       }
    //       return item;
    //     });
    // },
    // 進入本章學習
    startThisChapter() {
      this.activeNames = String(this.$route.query.chapterIndex) + "-0";
      this.chapterIndex = this.$route.query.chapterIndex;
      this.sectionIndex = 0;
      this.$router.push({
        query: {
          ...this.myQuery,
          chapterIndex: this.chapterIndex,
          sectionIndex: 0,
        },
      });
      // console.log("this.content.id:", this.content.id);
      // this.addUserCourseWare(this.content.id);
    },
    // 返回本章
    returnThisChapter() {
      this.activeNames = String(this.chapterIndex);
      this.sectionIndex = null;
      let query = {
        ...this.myQuery,
        chapterIndex: this.chapterIndex,
      };
      delete query.sectionIndex;
      this.$router.push({
        query: query,
      });
      // this.addUserCourseWare(this.content.id);
    },
    // 進入下一章
    startNextChapter() {
      this.activeNames = String(this.chapterIndex + 1);
      this.chapterIndex = this.chapterIndex + 1;
      this.sectionIndex = null;
      this.$router.push({
        query: {
          ...this.myQuery,
          chapterIndex: this.chapterIndex,
        },
      });
      // this.addUserCourseWare(this.content.id);
    },
    // 無語音 提示
    noAudioMessage() {
      this.$message({
        type: "warning",
        message: this.$t("message.noVoice"),
      });
    },
    // 监听audio都ended
    audioEnd() {
      this.audio.pause = true;
    },
    // 播放音頻
    play() {
      const soundLocale = this.soundLocale;
      if (soundLocale == "ZH_TW" || soundLocale == "ZH_CN") {
        this.$refs.myAudio.play();
        this.audio.pause = false;
      } else {
        if (this.hasAudio) {
          this.$refs.myAudio.play();
          this.audio.pause = false;
        } else {
          this.noAudioMessage();
        }
      }
    },
    // 暫停音頻
    pause() {
      this.$refs.myAudio.pause();
      this.audio.pause = true;
    },
    // 重新播放
    replay() {
      // let audio = document.getElementById("myAudio");
      // audio.currentTime = 0;
      const soundLocale = this.soundLocale;
      if (soundLocale == "ZH_TW" || soundLocale == "ZH_CN") {
        this.$refs.myAudio.muted = false;
        this.$refs.myAudio.currentTime = 0;
        this.$refs.myAudio.play();
        this.audio.pause = false;
        this.audio.muted = false;
        this.changeProgress();
      } else {
        if (this.hasAudio) {
          this.$refs.myAudio.muted = false;
          this.$refs.myAudio.currentTime = 0;
          this.$refs.myAudio.play();
          this.audio.pause = false;
          this.audio.muted = false;
          this.changeProgress();
        } else {
          this.noAudioMessage();
        }
      }
    },
    // 靜音
    muteMe() {
      this.$refs.myAudio.muted = true;
      this.audio.muted = true;
    },
    // 打開聲音
    sound() {
      this.$refs.myAudio.muted = false;
      this.audio.muted = false;
    },
    // 查詢是否有語音
    // checkAudio() {
    //   const soundLocale = this.soundLocale;
    //   if (soundLocale == "PT" || soundLocale == "EN") {
    //     AudioCheckAPI.checkAudio(this.content.id, soundLocale).then((res) => {
    //       this.hasAudio = res;
    //     });
    //   }
    // },
    // 進度條
    changeProgress() {
      const musicMp3 = this.$refs.myAudio;
      // console.log(musicMp3);
      const timer = setInterval(() => {
        const numbers = musicMp3.currentTime / musicMp3.duration;
        let perNumber = (numbers * 100).toFixed(2);
        if (perNumber >= 100) {
          this.isStore = true;
          this.progress = 0;
          clearInterval(timer);
        }
        perNumber += "%";
        this.progress = perNumber;
      }, 30);
    },
    // nodeClick(data, node) {
    //   console.log(data);
    //   console.log(node);
    //   if (data.sections) {
    //     this.handleOpenAndClose(data.index);
    //   } else {
    //     this.handleSectionChange(data, node.parent.data.index, data.index);
    //   }
    // },
    // 【節】選中
    handleSectionChange(val, chapterIndex, sectionIndex) {
      // console.log("handleSectionChange");
      // console.log(index);
      this.chapterIndex = chapterIndex;
      this.sectionIndex = sectionIndex;
      // this.content = val;
      this.activeNames = String(chapterIndex) + "-" + String(sectionIndex);

      if (val.id) {
        this.$router.push({
          query: {
            ...this.myQuery,
            chapterIndex: chapterIndex,
            sectionIndex: sectionIndex,
            activeName: "content",
          },
        });
        if (this.wWidth < 976) {
          this.addUserCourseWare(val.id);
        }
        this.showTipsDialog();
      }
    },
    // 【章】選中
    handleOpenAndClose(val) {
      // console.log("handleOpenAndCloseIndex:", val);
      const courseId = this.course.chapters[val].id;
      if (courseId == -1) {
        this.toTest();
      }
      this.sectionIndex = null;
      const num = parseInt(val);
      this.chapterIndex = num;

      let myQuery = this.myQuery;
      delete myQuery.sectionIndex;
      if (num >= 0) {
        this.activeNames = val.toString();
        this.$router.push({
          query: {
            ...this.myQuery,
            chapterIndex: num,
            activeName: "content",
          },
        });
        this.content = this.course.chapters[num];
        if (this.course.chapters[num].id != -1) {
          this.addUserCourseWare(courseId);
        }
      }
    },
    // 記錄用戶學習課件
    addUserCourseWare(id) {
      const auth = this.$store.state.auth;
      if (this.$store.state.isPreview && !auth) return false;
      if (auth) {
        CourseAPI.recordWares(id).catch((err) => {
          this.$error(err);
        });
      } else {
        UserCourseAPI.addUserCourseWare(id).catch((err) => {
          this.$error(err);
          // console.log(err);
        });
      }
    },
    // 參與模擬考試
    toTest() {
      // 課程不足80%提示
      if (this.course.progress < 0.8) {
        this.$alert(this.$t("message.test_tips"), this.$t("message.tips"), {
          confirmButtonText: this.$t("message.confirm"),
          callback: (action) => {
            // console.log(action);
          },
        });
        return false;
      }

      const courseId = sessionStorage.getItem("courseId");
      const lang = this.$i18n.locale;
      this.testLoading = true;
      UserAssessmentsAPI.assessment(courseId, lang)
        .then((res) => {
          this.testLoading = false;
          sessionStorage.setItem("testing", true);
          sessionStorage.setItem("questionCount", res.questionCount);
          sessionStorage.setItem("questionNum", 0);
          this.$router.push({
            path: "/learning/test",
            // query: { index: res.id }
          });
          // console.log(res);
        })
        .catch((err) => {
          this.testLoading = false;
          this.$error(err);
          // console.log(err);
        });
    },
    // 上一節
    prev() {
      this.sectionIndex = Number(this.sectionIndex) - 1;
      this.$router.push({
        query: {
          ...this.myQuery,
          chapterIndex: this.chapterIndex,
          sectionIndex: this.sectionIndex,
        },
      });
      this.activeNames =
        String(this.chapterIndex) + "-" + String(this.sectionIndex);
    },
    // 下一節
    next() {
      this.sectionIndex = Number(this.sectionIndex) + 1;
      this.$router.push({
        query: {
          ...this.myQuery,
          chapterIndex: this.chapterIndex,
          sectionIndex: this.sectionIndex,
        },
      });
      this.activeNames =
        String(this.chapterIndex) + "-" + String(this.sectionIndex);
      this.showTipsDialog();
    },
    // 打開連結
    openLink(link) {
      window.open(link);
    },
    // 自適應tab
    handleClick() {
      return;
    },
    // 獲取數據
    async get(chapterIndex) {
      this.loading = true;
      const courseId = sessionStorage.getItem("courseId");
      const locale = this.$i18n.locale;
      const sectionIndex = parseInt(this.sectionIndex);
      // console.log("sectionIndex:", this.sectionIndex);
      // console.log("sectionIndex:", sectionIndex);
      // console.log('chapterIndex:',chapterIndex);
      // console.log("get");

      if (courseId) {
        CourseAPI.getOne(courseId, locale)
          .then((res) => {
            this.loading = false;
            // res.chapters.push({
            //   code: "test",
            //   title: this.$t("message.practice_test"),
            //   text: "",
            //   language: this.$i18n.locale,
            //   sections: [],
            //   id: -1
            // });
            for (let i in res.chapters) {
              res.chapters[i].index = Number(i);
              const sections = res.chapters[i].sections;
              for (let j in sections) {
                sections[j].index = Number(j);
              }
            }
            this.course = res;
            // 處理菜單展開及顯示數據
            if (sectionIndex >= 0) {
              this.content = res.chapters[chapterIndex].sections[sectionIndex];
            } else {
              this.content = res.chapters[chapterIndex];
            }
            if (this.$refs.viewContent) this.$refs.viewContent.scrollTop = 0;
            // console.log("this.content:", this.content);
            if (this.content) this.addUserCourseWare(this.content.id);
            this.photoPreview();
          })
          .catch((err) => {
            this.loading = false;
            this.$error(err);
            // console.log(err);
          });
      } else {
        this.$router.push("/learning");
      }
    },
    // 最後瀏覽章節跳轉
    lastLocation() {
      const last = this.$store.state.last.chapters[0] || null;
      const chapters = this.course.chapters;
      const chapterIndex =
        (last && last.id && chapters.findIndex((item) => item.id == last.id)) ||
        0;
      // console.log("last:", last);
      // console.log("chapters:", chapters);
      // console.log("chapterIndexa:", chapterIndex);
      if (chapterIndex >= 0 && last && last.sections.length > 0) {
        const sectionIndex = chapters[chapterIndex].sections.findIndex(
          (item) => item.id == last.sections[0].id
        );
        this.activeNames = `${chapterIndex}-${sectionIndex}`;
        this.chapterIndex = chapterIndex;
        this.sectionIndex = sectionIndex;
        this.$router.push({
          query: {
            ...this.myQuery,
            chapterIndex: chapterIndex,
            sectionIndex: sectionIndex,
          },
        });
      } else {
        // console.log('chapterIndex',chapters.findIndex(item => item.id == last.id));
        this.activeNames = `${chapterIndex}`;
        this.chapterIndex = chapterIndex;
        this.$router.push({
          query: {
            ...this.myQuery,
            chapterIndex: chapterIndex,
          },
        });
      }
    },
    photoPreview() {
      // 图片方法
      setTimeout(() => {
        var previewDom = document
          .getElementById("courseView_html")
          .getElementsByTagName("img");
        if (previewDom.length < 1) {
          this.photoPreview();
        } else {
          for (let i = 0; i < previewDom.length; i++) {
            if (!previewDom[i].parentNode.getAttribute("href")) {
              //判斷有沒有連結，有的話不能打開大圖
              previewDom[i].setAttribute("preview", "1");
            }
          }
          this.$previewRefresh();
        }
      }, 1000);
    },
    // 獲取問卷數據
    getQuestionnaire(){
      const courseId = sessionStorage.getItem("courseId") || null;
      const locale = this.$i18n.locale;
      if(courseId){
        CourseAPI.listQuestionnaireByCourse(courseId, locale)
          .then(res => {
            this.loading = false;
            this.questionnaire = res;
          })
          .catch(err => {
            this.loading = false;
            this.$error(err);
          });
      }
    },
    // 打開問卷提示彈窗
    showTipsDialog(){
      const chapters = this.course && this.course.chapters;
      setTimeout(() => {
        if(this.questionnaire.length < 1) return;
        const questionnaire = this.questionnaire.length > 0 && this.questionnaire[0] || {};
        const chapterIndex = this.chapterIndex;
        const sectionIndex = this.sectionIndex;
        if(!questionnaire.participated && chapterIndex === chapters.length - 1 && sectionIndex === chapters[chapterIndex].sections.length - 1){
          this.showQuestionTips = true;
        }
      }, 1000);
    },
    // 獲取模擬考試
    getHasAssessment() {
      if (!this.$store.state.isPreview) {
        const courseId = sessionStorage.getItem("courseId") || null;
        const locale = this.$i18n.locale;
        if (courseId) {
          CourseAPI.checkHasAssessment(courseId, locale)
            .then((res) => {
              this.checkHasAssessment = res;
            })
            .catch((err) => {
              this.$error(err);
            });
        }
      }
    },
  },
  created() {
    this.last = this.$store.state.last;
    const sound = localStorage.getItem("sound") || "TW";
    if (sound == "CN") {
      this.soundLocale = "ZH_CN";
    } else if (sound == "E") {
      this.soundLocale = "EN";
    } else if (sound == "P") {
      this.soundLocale = "PT";
    } else {
      this.soundLocale = "ZH_TW";
    }
    this.activeNames = this.$route.query.sectionIndex
      ? String(this.$route.query.chapterIndex) +
        "-" +
        String(this.$route.query.sectionIndex)
      : String(this.$route.query.chapterIndex);
    this.activeNames = this.activeNames == "undefined" ? this.activeNames : "0";
    this.chapterIndex = this.$route.query.chapterIndex || 0;
    this.sectionIndex = this.$route.query.sectionIndex || null;

    this.defaultOpeneds = [String(this.$route.query.chapterIndex)];

    // 移動端tab切換
    this.activeName = this.$route.query.activeName || "content";

    this.get(parseInt(this.chapterIndex));

    // 獲取問卷數據
    this.getQuestionnaire();
    this.getHasAssessment();
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-tabs {
  border-bottom: 1px solid #dfdfdf;
  padding-bottom: 10px;

  .el-tabs__header {
    margin: 0px;

    .el-tabs__item {
      font-size: 16px;
      color: #3e4143;
    }

    .el-tabs__item:hover,
    .el-tabs__item.is-active {
      color: #16b695;
    }

    .el-tabs__active-bar {
      background-color: #16b695;
      height: 4px;
      border-radius: 3px;
      padding: 0 5px;
      left: -4px;
    }

    .el-tabs__nav-wrap::after {
      height: 0;
    }

    .el-tabs__nav {
      margin-left: 10px;
    }
  }
}
.sections_search {
  background: #fff !important;
  padding: 0 10px !important;
}
.courseView_content .html-box {
  font-size: 18pt;
  line-height: 200%;
  color: #000000;
  font-weight: normal;
  font-style: normal;
}
</style>